// extracted by mini-css-extract-plugin
export default {"inputWrapper":"TextInput_inputWrapper__478+y","tooltip":"TextInput_tooltip__nP8Ym"};